import { TvBaseFormatter } from './TvBaseFormatter';
export class TvSpreadFormatter extends TvBaseFormatter {
    constructor(symbol) {
        super(symbol);
    }
    format(value) {
        if (this.instrument) {
            const tickSize = this.instrument.getPointSize(null);
            if (tickSize === 0)
                return this.instrument.formatPrice(value);
            const ticks = Math.round(value / tickSize);
            return `${ticks} ticks`; // TODO: localization
        }
        return value.toString();
    }
    parse(value) {
        const valueWithoutTicks = value.replace(/ ticks$/, '');
        return super.parse(valueWithoutTicks);
    }
}
